import eventBus from '@/services/eventBus'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'

const created = (item: IOrganization) => {
  eventBus.pub('organizations.created', item)
}

const updated = (item: IOrganization) => {
  eventBus.pub('organizations.updated', item)
}

const deleted = (id: IOrganization['id']) => {
  eventBus.pub('organizations.deleted', id)
}

const organizationsEvents = { created, updated, deleted }
export default organizationsEvents
